var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMadeTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.55,175.75H51a3.4,3.4,0,0,1-3.4-3.4V99.89a3.4,3.4,0,0,1,6.8,0V169H158.15V99.89a3.4,3.4,0,1,1,6.8,0v72.46A3.4,3.4,0,0,1,161.55,175.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.2,101.8H33.4a3.4,3.4,0,0,1-2.12-6.06l72.9-58.15a3.4,3.4,0,0,1,4.24,0l72.9,58.15a3.4,3.4,0,0,1-2.12,6.06ZM43.12,95H169.48L106.3,44.6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMadeTag);
export default __webpack_public_path__ + "static/media/HomeMadeTag.b0ae8473f1699c256f048644cc212622.svg";
export { ForwardRef as ReactComponent };